import React from "react";
import { Col, Row } from "react-bootstrap";
import { styled } from "@mui/material/styles";

function TextLink() {
  const TestWork = styled("div")(({ theme }) => ({
    color: theme.palette.linktext?.color,
    cursor: "pointer",
    "&:hover": {
      color: `${theme.palette.linktext?.hovercolor} !important`,
    },
  }));
  return (
    <>
      <div className="w-75 mx-auto m-3  p-3 rounded">
        <div className=" d-block">
          <Row className="justify-content-around align-items-center">
            <Col lg={12} md={12}>
              <TestWork className=" m-0 text-decoration-underline ">
                In case the system doesn't recognize your flight, send us a
                manual booking request
              </TestWork>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default TextLink;
